import MultiOddsBoostsDialogImpl from './multi-odds-boosts-dialog.js';
import MojitoCore from 'mojito/core';
import PropTypes from 'prop-types';

const UIView = MojitoCore.Presentation.UIView;

/**
 * Component to display dialog for multiple odds boosts.
 *
 * @class MultiOddsBoostsDialog
 * @memberof Mojito.Modules.BetslipView
 */

/**
 * MultiOddsBoostsDialog prop types.
 *
 * @property {Mojito.Services.Betslip.types.OddsBoost} [boosts = []] - Array of available odds boosts.
 * @property {boolean} isOpen - Determines if the dialog should be displayed.
 * @property {Function} onClose - Called when the user wants to close the dialog.
 * @property {Function} onApply - Called when the user applies a boost.
 *
 * @memberof Mojito.Modules.BetslipView.MultiOddsBoostsDialog
 */
const propTypes = {
    boosts: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            title: PropTypes.string,
            text: PropTypes.string,
            expireDate: PropTypes.string,
        })
    ),
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onApply: PropTypes.func.isRequired,
};

const defaultProps = {
    boosts: [],
};

export default UIView('MultiOddsBoostsDialog', MultiOddsBoostsDialogImpl, propTypes, defaultProps);
